import React, { FC } from "react";
import styles from "./HtcLogo.module.css";

const Logo: FC = () => {
    return (
        <img className={styles.logo} src={process.env.PUBLIC_URL + "/assets/halvotec_hexagon_tec.svg"} />
    );
}

export default Logo;